






















import { editFactory } from '@/main/pages';
import { NdSklad } from '@/modules/sklad/ndSklad';

import { store } from './store/edit';
import { NAME } from './constants';
import { editActions } from './store/types';

export default editFactory(NAME, store).extend({
	components: {
		NdSkladSelect: NdSklad.components.Select,
	},
	computed: {
		actionsMapper() {
			return {
				ndSklad: `${this.storeUri}/${editActions.ND_SKLAD_SELECT_MAPPER}`,
			};
		},
		ndskladFilter() {
			return {
				VyrobekndOzn: this.VyrobekndOzn,
				NdNr: this.NdNr,
				NdText: this.ndText,
			};
		},
	},
});
